import { getWindow } from '@utils/window'

interface CookiePreferences {
  marketing: boolean | undefined
  social: boolean | undefined
}

const getCookiePreferences = (): CookiePreferences => {
  const w = getWindow()
  if (!w.uSwitch.cookie.read('cookie-preferences'))
    return {
      marketing: undefined,
      social: undefined
    }

  return JSON.parse(w.uSwitch.cookie.read('cookie-preferences') ?? '') as CookiePreferences
}

export const hasAcceptedMarketing = (): boolean => {
  const cookieConsent = getCookiePreferences()
  if (!cookieConsent || !cookieConsent.marketing || !cookieConsent.social) return false
  return cookieConsent.marketing ?? cookieConsent.social
}
